import { render, staticRenderFns } from "./proposal-22-hiring-area.vue?vue&type=template&id=4554c792"
import script from "./proposal-22-hiring-area.vue?vue&type=script&lang=js"
export * from "./proposal-22-hiring-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports